//libs
import React,{Component} from "react";
import {connect} from "react-redux";
import axios from 'axios';
//other
import {setTrue} from "../../../actions/refresh";
import {post as createStation, put as updateStation, getGroupTypes} from "../../../actions/stations";
import {post as createWheelChanger, put as updateWheelChanger} from "../../../actions/wheelChangers";
import Config from "../../../config";
import {notification,isAdmin} from "../../../helpers";
import TextField from "./Form_Elements/TextField";
import PopUp from "./PopUp";



class DeleteWheelForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            regno:"",
            waggonNo: "",
            showConfirmation: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this)

        this.handleChange = this.handleChange.bind(this)
    }

    confirmAction(){
        this.setState({
            showConfirmation:true
        });
    }

    handleConfirm(){
        this.setState({
            showConfirmation:false
        });
        this.handleDelete();

    }

    handleCancel(){
        this.setState({
            showConfirmation:false
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.confirmAction();
    }

    handleChange(e,id) {

        let currentState = this.state;
        currentState[id] = e.target.value;

        this.setState(currentState);
    }

    handleDelete() {

        if (!isAdmin()){
            return false;
        }

        let requestUrl = Config.api.getDomain() + 'admin/deleteWheel/'+this.state.regno+'/'+this.state.waggonNo+'';

        axios.delete(requestUrl,Config.api.getConfig())
        .then(response => {
            this.setState({
                regno:"",
                waggonNo:""
            })
            notification(response.data.message);
        })
        .catch(error => {
            let rsp = JSON.parse(error.request.response);
            notification(rsp.message);
        })
    }

    handleDateChangeRaw(e){
        e.preventDefault()
    }

    render() {
        //[12:34] Niklas Hägg
        // /api/admin/deleteWheel/{regno}/{waggonNo}

        if (!isAdmin()){
            return null;
        }

        let buttonTitle="Ta bort";
        let title="Ta bort bil från databas";

        let wheelType = (
            <TextField
                title={"Registreringsnummer"}
                name='regno'
                id='regnoDelete'
                value={this.state.regno}
                onChange={(e)=>this.handleChange(e,'regno')}
            />
        );

        let regNr = (
            <TextField
                title={"Vagnsnummer"}
                name='waggonNo'
                id='waggonNoDelete'
                value={this.state.waggonNo}
                onChange={(e)=>this.handleChange(e,'waggonNo')}
            />
        );

        return (
            <div className='box edit-last-on-rent-date'>
                <div className='box-inner'>
                    <h2>{title}</h2>
                    <form onSubmit={this.handleSubmit}>

                        <div className='date'>

                            {wheelType}

                            {regNr}

                        </div>

                        <input
                            disabled={(!this.state.regno) || (!this.state.waggonNo)}
                            type="submit"
                            // disabled={!this.validateForm()}
                            className="submit creategroupsubmit form-submit"
                            value={buttonTitle}
                        />
                    </form>

                    {this.state.showConfirmation &&
                        <PopUp
                            title="Ta bort bil från databas?"
                            show={true}
                            onAccept={(e)=>this.handleConfirm(e)}
                            onCancel={(e)=>this.handleCancel(e)}
                        />
                    }


                </div>
            </div>



        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForEditLastOnRentDate = (state) => {
    return {
        refresh: state.refresh,
        submitting: state.stations.submitting,
        groupTypes: state.stations.groupTypes,
        groups: state.stations.groups
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForEditLastOnRentDate = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key)),
        createStation:(data) => dispatch(createStation(data)),
        createWheelChanger:(data) => dispatch(createWheelChanger(data)),
        getGroupTypes:()=>dispatch(getGroupTypes()),
        updateStation:(data) => dispatch(updateStation(data)),
        updateWheelChanger:(data) => dispatch(updateWheelChanger(data))
    };
};

/**
 * Create groups
 */
export default connect(mapStateToPropsForEditLastOnRentDate, mapDispatchToPropsForEditLastOnRentDate)(DeleteWheelForm);



// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/DeleteWheelForm.js